let config: any = {}

const getSlideApiGatewayPath = () => config.slide_api_gateway || ''
const getCTPath = () => config.ct || ''
const getHomePath = () => config.home_path || ''
const getAssetsPath = () => config.assets_path || ''
const setConfig = (_config: any) => (config = _config)

export default {
	setConfig,
	getHomePath,
	getAssetsPath,
	getSlideApiGatewayPath,
	getCTPath,
}
